import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBreak = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		d: "M7 3.667v-2m-2.667 2v-2m5.334 2v-2M4.333 14.333h6c.737 0 1.334-.597 1.334-1.333V5.667A.667.667 0 0 0 11 5H3.667A.667.667 0 0 0 3 5.667V13c0 .736.597 1.333 1.333 1.333Zm7.334-8h.666a2 2 0 1 1 0 4h-.666z"
	})
});
export default SvgBreak;
